export default {
  loyalty: null,
  loyaltyClient: null,
  loyaltyClientTransactions: null,
  loyaltySegmentationConfig: null,
  loyaltySegmentation: null,
};
